// extracted by mini-css-extract-plugin
export default {"image":"ImageGalleryItem_image__NRKYb","item":"ImageGalleryItem_item__iuWHh"};